import React, { useEffect } from "react";

import "./ImageContentViewer.css";

export default function ImageContentViewer({ content, fileUrl, onTrack }) {
    useEffect(() => {
        const timerId = window.setInterval(() => {
            if (!document.hidden) {
                onTrack?.({
                    timeSpentDeltaSeconds: 1,
                    completionPercent: 25,
                    progressPayload: {
                        opened: true,
                    },
                });
            }
        }, 1000);

        return () => window.clearInterval(timerId);
    }, [content?.id, onTrack]);

    return (
        <div className="cr-image-wrap icv-wrap">
            <img className="cr-image" src={fileUrl} alt={content.title} />
        </div>
    );
}
